export enum TopicTypes {
  Calendar = 1,
  Notice = 2,
  News = 3,
  Email = 20,
}
